<template>
    <el-card class="reportsList">
        <div style=" font-size: 16px;
        font-weight: 900;">事件报表细化</div>
        <ul>
            <router-link :to="{path:'/classifyStatistics'}">
                <li>事件分类统计</li>
            </router-link>
            <router-link :to="{path:'/eventCloseClassify'}">
                <li>事件关闭分类统计</li>
            </router-link>
            <router-link :to="{path:'/eventCloseClassifyGroup'}">
                <li>事件关闭分类按组统计</li>
            </router-link>
        </ul>
    </el-card>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .reportsList{
        /*height: 120px;*/
        background: white;
        font-size: 15px;
    }
    .reportsList div{
        padding-left: 15px;
    }
    .reportsList ul{
        float: left;
        margin: 20px 10px 10px 10px;

    }
    .reportsList ul li{
        color: grey;
        float: left;
        margin: 5px 35px 5px 5px;
    }
</style>
